import React from 'react';
import { FormField } from '../FormField';
import { FormFieldType } from '@/types/form';

interface DevelopmentSectionProps {
  elementGroups: {
    topicElements: FormFieldType[];
    knowledgeElements: FormFieldType[];
    skillsElements: FormFieldType[];
    attitudeElements: FormFieldType[];
    otherElements: FormFieldType[];
  };
}

const DevelopmentSection: React.FC<DevelopmentSectionProps> = ({ elementGroups }) => {
  return (
    <>
      {/* Topic Section */}
      <div className="mb-8">
        {elementGroups.topicElements.map((element) => (
          <FormField key={element.id} element={element} />
        ))}
      </div>

      {/* Knowledge Section */}
      <div className="p-4 rounded-lg bg-red-50 border border-red-100 mb-6">
        <h3 className="text-lg font-semibold text-red-600 mb-4">มิติที่ 1: ความรู้ (Knowledge)</h3>
        {elementGroups.knowledgeElements.map((element) => (
          <FormField key={element.id} element={element} />
        ))}
      </div>

      {/* Skills Section */}
      <div className="p-4 rounded-lg bg-blue-50 border border-blue-100 mb-6">
        <h3 className="text-lg font-semibold text-blue-600 mb-4">มิติที่ 2: ทักษะ (Skills)</h3>
        {elementGroups.skillsElements.map((element) => (
          <FormField key={element.id} element={element} />
        ))}
      </div>

      {/* Attitude Section */}
      <div className="p-4 rounded-lg bg-purple-50 border border-purple-100 mb-6">
        <h3 className="text-lg font-semibold text-purple-600 flex-1 mb-4">มิติที่ 3: ทัศนคติ (Attitude)</h3>
        {elementGroups.attitudeElements.map((element) => (
          <FormField key={element.id} element={element} />
        ))}
      </div>

      {/* Other Fields */}
      {elementGroups.otherElements.map((element) => (
        <FormField key={element.id} element={element} />
      ))}
    </>
  );
};

export default DevelopmentSection;
